import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Question} from 'src/app/models';
import {FaqService} from 'src/app/services';

@Component({
    selector: 'app-question-create',
    templateUrl: './question-update.component.html',
    styleUrls: ['./question-update.component.scss']
})
export class QuestionUpdateComponent {
    newQuestion: Question;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private questionService: FaqService
    ) {
        this.newQuestion = new Question(this.data.question.id, this.data.question.category, this.data.question.question, this.data.question.answer);
    }

    save() {
        this.questionService.updateQuestion(this.newQuestion).subscribe();
    }

}
